import { jsx as t } from "react/jsx-runtime";
import { i as s } from "./index-BBp_EiPc.js";
const m = ({ icon: r, ...o }) => {
  if (!r) return null;
  const n = s[r];
  return n ? /* @__PURE__ */ t(n, { ...o }) : null;
};
export {
  m as I
};
